import { useEffect } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useAuth } from '../contexts/AuthContext';
import { apiClient } from '../api/client';

export function ThemeSyncProvider({ children }: { children: React.ReactNode }) {
  const { setSyncFunction } = useTheme();
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      // Set up the sync function when user is logged in
      setSyncFunction(async (theme: string) => {
        try {
          const currentSettings = await apiClient.getUserSettings();
          await apiClient.updateUserSettings({
            ...currentSettings,
            theme: theme as 'light' | 'dark' | 'system'
          });
        } catch (error) {
          console.error('Failed to sync theme with backend:', error);
          throw error;
        }
      });
    } else {
      // Clear sync function when logged out
      setSyncFunction(async () => {});
    }
  }, [user, setSyncFunction]);

  return <>{children}</>;
}